const ChamberRowService = {

    /**
     * Returns true if there are no inactive chambers between the first and last active chambers.
     * 
     * @param row The chamber row to interrogate
     */
    isUnbrokenRow: (row) => {
        let result = true;
        const firstActiveChamber = row.getFirstActiveChamber();
        const lastActiveChamber = row.getLastActiveChamber();
        for (let index = firstActiveChamber.col; index < lastActiveChamber.col; index++) {
            if (!row.chambers[index].active) {
                result = false;
                break;
            }
        }
        return result;
    },

    /**
     * Returns true if there are no inactive chambers between the first and last active chambers.
     * 
     * @param row The chamber row to interrogate
     */
    isUnbrokenInBetween: (row, colStart, colEnd) => {
        let result = true;
        let cols = [colStart, colEnd];
        cols.sort((a, b) => a - b);
        for (let index = cols[0]; index <= cols[1]; index++) {
            if (!row.chambers[index].active) {
                result = false;
                break;
            }
        }
        return result;
    }
};

export default ChamberRowService;


// WEBPACK FOOTER //
// ./src/lib/services/chamber-row-service.js